module.exports = __webpack_public_path__ + "ddfaa602a15f5fc02cb3e5ba38b2fbda.pdf";